import { LinearProgress } from '@gto/ui/linear-progress'

/**
 * Non-blocking indicator for a `keepPreviousData` refetch — stale rows stay visible beneath so
 * the user keeps context. `pointer-events-none` so it never blocks scroll; `aria-hidden`
 * because `aria-busy` + the live region carry the semantics.
 *
 * A 4px indeterminate bar, DataGridPro's `loadingOverlay variant: 'linear-progress'` — the
 * shape the hands grid shipped with. A centred spinner (what this rendered first) both dimmed
 * more of the table than the refetch warranted and, being 28px tall inside the scroll FLOW,
 * pushed the sticky summary band up off the card's bottom edge at full scroll.
 *
 * ABSOLUTE on the card (a non-scrolling sibling of the grid, like the pinned shadow rails),
 * NOT sticky inside the scroll flow: an in-flow element rendered after the body has its
 * natural position at the BOTTOM of the content, and `position: sticky` never lifts an
 * element above its flow position — so the bar only ever surfaced near full scroll.
 * `topOffset` (the header band's height) parks it directly under the sticky header.
 */
export const RefetchOverlay = ({ topOffset = 0 }: { topOffset?: number }) => (
  <div
    aria-hidden
    className="pointer-events-none absolute inset-x-0 z-10"
    data-table-state="refetching"
    style={{ top: topOffset }}
  >
    <LinearProgress
      size="sm"
      type="indeterminate"
    />
  </div>
)
